let categories = [
    {
        id:1,
        name: 'Bedroom',
        count:10,

    },
    {
        id:2,
        name: 'Kitchen Ware',
        count:10,
        
    },
    {
        id:3,
        name: 'Electricals',
        count:10,
        
    },
    {
        id:4,
        name: 'Plumbing',
        count:10,
        
    }


]

let products = [
    {
        name:"Hoodie",
        price:20.00
    },
    {
        name:"Mat",
        price:10.00
    },
    {
        name:"Iron",
        price:200.00
    },
    {
        name:"Phone",
        price:200.00
    },
   
]
export function getCategories() {
    return categories;
}

export function getProducts(){
    return products;
}


